import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEoWebComponentsModule } from 'ngx-eo-web-components';
import { DetailPanelComponent } from './components/detail-panel/detail-panel.component';
import { DetailComponent } from './components/detail/detail.component';
import { ImageButtonComponent } from './components/image-button/image-button.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalComponent } from './components/modal/modal.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { RoleDropdownComponent } from './components/role-dropdown/role-dropdown.component';
import { SearchResultsOptionsComponent } from './components/search-results-options/search-results-options.component';
import { TableComponent } from './components/table/table.component';
import { PrimengModule } from './primeng.module';
import { HospitalDropdownComponent } from './components/hospital-dropdown/hospital-dropdown.component';
import { ClinicDropdownComponent } from './components/clinic-dropdown/clinic-dropdown.component';
import { IcdDropdownComponent } from './components/icd-dropdown/icd-dropdown.component';
import { DrgDropdownComponent } from './components/drg-dropdown/drg-dropdown.component';
import { MetricComponent } from './components/metric/metric.component';
import { HospitalUserDropdownComponent } from './components/hospital-user-dropdown/hospital-user-dropdown.component';
import { HasRoleDirective } from './directives/app-has-role.directive';
import { AppSurgeryViewPanelComponent } from './components/app-surgery-view-panel/app-surgery-view-panel.component';

@NgModule({
  declarations: [
    DetailComponent,
    ImageButtonComponent,
    LoadingComponent,
    TableComponent,
    SearchResultsOptionsComponent,
    DetailPanelComponent,
    ModalComponent,
    PageHeaderComponent,
    RoleDropdownComponent,
    HospitalDropdownComponent,
    ClinicDropdownComponent,
    IcdDropdownComponent,
    DrgDropdownComponent,
    MetricComponent,
    HospitalUserDropdownComponent,
    HasRoleDirective,
    AppSurgeryViewPanelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEoWebComponentsModule,
    PrimengModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    NgxEoWebComponentsModule,
    DetailComponent,
    ImageButtonComponent,
    LoadingComponent,
    TableComponent,
    SearchResultsOptionsComponent,
    DetailPanelComponent,
    ModalComponent,
    PageHeaderComponent,
    RoleDropdownComponent,
    HospitalDropdownComponent,
    ClinicDropdownComponent,
    IcdDropdownComponent,
    DrgDropdownComponent,
    MetricComponent,
    HospitalUserDropdownComponent,
    HasRoleDirective,
    AppSurgeryViewPanelComponent
  ],
})
export class SharedModule {}
